import { render, staticRenderFns } from "./FbPaginacion.vue?vue&type=template&id=54d37c60&scoped=true&"
import script from "./FbPaginacion.vue?vue&type=script&lang=js&"
export * from "./FbPaginacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d37c60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54d37c60')) {
      api.createRecord('54d37c60', component.options)
    } else {
      api.reload('54d37c60', component.options)
    }
    module.hot.accept("./FbPaginacion.vue?vue&type=template&id=54d37c60&scoped=true&", function () {
      api.rerender('54d37c60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/_vue/componentes/FbPaginacion.vue"
export default component.exports